import colors from 'vuetify/lib/util/colors.mjs';
import { AppColors } from '@/themes/theme';

export const dpmdasColors: Partial<AppColors> = {
  systemPrimary: '#346198',
  systemSecondary: '#346198',
  buttonPrimary: '#346198',
  primary: '#346198',
  buttonWarning: '#FF0000',
  buttonConfirm: colors.green.darken2,
  buttonDefault: colors.grey.darken1,
  rdpbackground: '#FFFFFF',
  leftpanelhover: '#346198',
};
